import Chart from 'chart.js'

class chartRender {
  _construct() {
    this.$registers = document.querySelector('#registersPerDay');
    this.$scholarshipsDAN = document.querySelector('#scholarshipsDatedAndNews');
    this.$scholarshipsAAR = document.querySelector('#scholarshipsAcceptedAndRejected');
  }

  _registersPerDay() {
    const self = this;
    let days = [],
        dataset = [],
        collection = JSON.parse(self.$registers.getAttribute('data-set'));

    for(let key in collection) {
      days.push(key);
      dataset.push(collection[key]);
    }

    let registersChart = new Chart(self.$registers, {
      type: 'line',
      data: {
        labels: days,
        datasets: [{
          label: '# de registros por día',
          data: dataset,
          backgroundColor: 'rgba(53, 80, 166, 0.14)',
          borderColor: 'rgba(53, 80, 166, 1)',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  _scholarshipsDatedAndNews() {
    const self = this;
    let dataset = JSON.parse(self.$scholarshipsDAN.getAttribute('data-set'));

    let scholarshipsChart = new Chart(self.$scholarshipsDAN, {
      type: 'pie',
      data: {
        datasets: [{
          data: [dataset.scheduled, dataset.new],
          backgroundColor: ['rgba(15, 130, 200, 0.14)', 'rgba(13, 95, 236, 0.14)'],
          borderColor: ['rgba(15, 130, 200, 1)', 'rgba(13, 95, 236, 1)'],
        }],
        labels: [
          'Agendadas',
          'Nuevas'
        ]
      }
    });
  }

  _scholarshipsAcceptedAndRejected() {
    const self = this;
    let dataset = JSON.parse(self.$scholarshipsAAR.getAttribute('data-set'));

    let scholarshipsChart = new Chart(self.$scholarshipsAAR, {
      type: 'pie',
      data: {
        datasets: [{
          data: [dataset.accepted, dataset.rejected],
          backgroundColor: ['rgba(15, 130, 200, 0.14)', 'rgba(13, 95, 236, 0.14)'],
          borderColor: ['rgba(15, 130, 200, 1)', 'rgba(13, 95, 236, 1)'],
        }],
        labels: [
          'Aceptadas',
          'Rechazadas'
        ]
      }
    });
  }

  init() {
    this._construct();
    const self = this;

    self._registersPerDay();
    self._scholarshipsDatedAndNews();
    self._scholarshipsAcceptedAndRejected();
  }
}

export default chartRender
